<template>
  <div
    class="map-frame"
    :class="[mapId == 'container-footer' ? 'footer-map' : this.mapId]"
    v-if="type == 'OpenStreetMap'"
  >
    <l-map
      @mouseover="scrollWithCtrl"
      :zoom="zoom"
      :center="[latitude, longitude]"
      :options="{
        zoomControl: this.addressOptions.zoomControl,
        disableScrollPropagation: this.addressOptions.disableScrollPropagation,
        scrollWheelZoom: this.addressOptions.scrollWheelZoom,
        touchZoom: this.addressOptions.touchZoom,
        doubleClickZoom: this.addressOptions.doubleClickZoom,
        keyboard: this.addressOptions.keyboard,
        dragging: this.addressOptions.dragging,
      }"
    >
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ></l-tile-layer>

      <l-marker
        v-if="showAddress != 0"
        :lat-lng="[latitude, longitude]"
      ></l-marker>

      <l-control position="topright">
        <button
          type="button"
          class="map-fullscreen-button"
          @click="clickHandler"
        >
          <svg
            version="1.1"
            id="Ebene_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 42 42"
            style="enable-background: new 0 0 42 42"
            xml:space="preserve"
          >
            <g
              id="Gruppe_478"
              transform="matrix(0.999, -0.035, 0.035, 0.999, 29.001, 2.563)"
            >
              <path id="Pfad_445" class="st0" d="M-7.4-0.4L10,0.2L9.3,17.5" />
            </g>
            <line
              id="Linie_363"
              class="st1"
              x1="39"
              y1="2.9"
              x2="3.3"
              y2="38.5"
            />
            <g
              id="Gruppe_3772"
              transform="translate(27.991 56.591) rotate(-180)"
            >
              <path
                id="Pfad_445-2"
                class="st2"
                d="M7.6,16.9L25,17.4l-0.5,17.3"
              />
            </g>
          </svg>
        </button>
      </l-control>
    </l-map>
    <div class="map-overlay">
      <span class="language de"
        >Verwende Strg + Scrollen zum Zoomen der Karte</span
      >
      <span class="language es"
        >Utilice Ctrl+ barra de desplazamiento para ampliar el mapa</span
      >
      <span class="language it"
        >Usare Ctrl e fare scorrere il mouse per ingrandire la mappa</span
      >
      <span class="language en">Use Ctrl+ scroll to zoom in the map</span>
    </div>
  </div>
  <div v-if="type == 'FileMap'" class="map-image col-12">
    <button type="button" class="map-fullscreen-button" @click="clickHandler">
      <svg
        version="1.1"
        id="Ebene_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 42 42"
        style="enable-background: new 0 0 42 42"
        xml:space="preserve"
      >
        <g
          id="Gruppe_478"
          transform="matrix(0.999, -0.035, 0.035, 0.999, 29.001, 2.563)"
        >
          <path id="Pfad_445" class="st0" d="M-7.4-0.4L10,0.2L9.3,17.5" />
        </g>
        <line id="Linie_363" class="st1" x1="39" y1="2.9" x2="3.3" y2="38.5" />
        <g id="Gruppe_3772" transform="translate(27.991 56.591) rotate(-180)">
          <path id="Pfad_445-2" class="st2" d="M7.6,16.9L25,17.4l-0.5,17.3" />
        </g>
      </svg>
    </button>
    <img :src="`${path}`" alt="" style="width: 100%" />
  </div>

  <div class="map-frame-modal" :class="[type == 'FileMap' ? 'file-map' : '']">
    <template v-if="type == 'OpenStreetMap'">
      <l-map
        @mouseover="scrollWithCtrl"
        :zoom="zoom"
        :center="[latitude, longitude]"
        :options="{
          zoomControl: this.addressOptions.zoomControl,
          disableScrollPropagation:
            this.addressOptions.disableScrollPropagation,
          scrollWheelZoom: this.addressOptions.scrollWheelZoom,
          touchZoom: this.addressOptions.touchZoom,
          doubleClickZoom: this.addressOptions.doubleClickZoom,
          keyboard: this.addressOptions.keyboard,
          dragging: this.addressOptions.dragging,
        }"
      >
        <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        ></l-tile-layer>
        <l-marker
          v-if="showAddress != 0"
          :lat-lng="[latitude, longitude]"
        ></l-marker>
        <l-control position="topright">
          <button type="button" class="map-close-button" @click="clickHandler">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--mainColor)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-minimize"
            >
              <path
                d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
              ></path>
            </svg>
          </button>
        </l-control>
      </l-map>
      <div class="map-overlay">
        <span class="language de"
          >Verwende Strg + Scrollen zum Zoomen der Karte</span
        >
        <span class="language es"
          >Utilice Ctrl+ barra de desplazamiento para ampliar el mapa</span
        >
        <span class="language it"
          >Usare Ctrl e fare scorrere il mouse per ingrandire la mappa</span
        >
        <span class="language en">Use Ctrl+ scroll to zoom in the map</span>
      </div>
    </template>
    <template v-if="type == 'FileMap'">
      <button type="button" class="map-close-button" @click="clickHandler">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-minimize"
        >
          <path
            d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
          ></path>
        </svg>
      </button>
      <img :src="`${path}`" alt="" style="width: 100%" />
    </template>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LControl } from "@vue-leaflet/vue-leaflet";

export default {
  props: {
    mapId: {
      type: Array,
    },
    latitude: {
      type: String,
    },
    longitude: {
      type: String,
    },
    showAddress: {
      type: String,
    },
    type: {
      type: String,
    },
    path: {
      type: String,
    },
  },

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
  },

  methods: {
    clickHandler(event) {
      const modalContainer = event.target.closest("section");
      let mapModal = modalContainer.querySelector(".map-frame-modal");
      mapModal.classList.toggle("map-visible");
    },

    scrollWithCtrl() {
      const map = document.querySelector(`.${this.mapId} .leaflet-container`);
      const mapOverlay = document.querySelector(`.${this.mapId} .map-overlay`);
      const zoomInButton = document.querySelector(
        `.${this.mapId} .leaflet-control-zoom-in`
      );
      const zoomOutButton = document.querySelector(
        `.${this.mapId} .leaflet-control-zoom-out`
      );

      map.onwheel = function (e) {
        if (e.ctrlKey) {
          e.preventDefault();
          mapOverlay.style.opacity = "0";
          if (e.wheelDelta > 0) {
            zoomInButton.click();
          } else {
            zoomOutButton.click();
          }
        } else {
          mapOverlay.style.opacity = "1";
          mapOverlay.style.display = "flex";
        }
      };

      mapOverlay.addEventListener(
        "mouseenter",
        function (e) {
          // highlight the mouseenter target
          e.target.style.opacity = "1";

          // reset the color after a short delay
          setTimeout(function () {
            e.target.style.opacity = "0";
          }, 2000);
        },
        false
      );

      mapOverlay.addEventListener(
        "mouseleave",
        function (e) {
          setTimeout(function () {
            e.target.style.opacity = "0";
          }, 1000);
        },
        false
      );

      mapOverlay.addEventListener("transitionend", function () {
        if (this.style.opacity == "1") {
          this.style.display = "flex";
        } else if (this.style.opacity == "0") {
          this.style.display = "none";
        }
      });
    },

    getOptions() {
      if (this.showAddress == 0) {
        this.addressOptions.zoomControl = false;
        this.addressOptions.disableScrollPropagation = true;
        this.addressOptions.scrollWheelZoom = false;
        this.addressOptions.touchZoom = false;
        this.addressOptions.doubleClickZoom = false;
        this.addressOptions.keyboard = false;
        this.addressOptions.dragging = false;
      } else if (this.showAddress == 1) {
        this.addressOptions.zoomControl = true;
        this.addressOptions.disableScrollPropagation = false;
        this.addressOptions.scrollWheelZoom = false;
        this.addressOptions.touchZoom = true;
        this.addressOptions.doubleClickZoom = true;
        this.addressOptions.keyboard = true;
        this.addressOptions.dragging = true;
      }
    },

    checkLanguage() {
      var userLang = navigator.language;
      var languageDe = document.querySelectorAll("span.de");
      var languageEs = document.querySelectorAll("span.es");
      var languageIt = document.querySelectorAll("span.it");
      var languageEn = document.querySelectorAll("span.en");

      if (userLang.includes("de")) {
        languageDe.forEach((el) => (el.style.display = "block"));
        languageEs.forEach((el) => (el.style.display = "none"));
        languageIt.forEach((el) => (el.style.display = "none"));
        languageEn.forEach((el) => (el.style.display = "none"));
      } else if (userLang.includes("es")) {
        languageDe.forEach((el) => (el.style.display = "none"));
        languageEs.forEach((el) => (el.style.display = "block"));
        languageIt.forEach((el) => (el.style.display = "none"));
        languageEn.forEach((el) => (el.style.display = "none"));
      } else if (userLang.includes("it")) {
        languageDe.forEach((el) => (el.style.display = "none"));
        languageEs.forEach((el) => (el.style.display = "none"));
        languageIt.forEach((el) => (el.style.display = "block"));
        languageEn.forEach((el) => (el.style.display = "none"));
      } else {
        languageDe.forEach((el) => (el.style.display = "none"));
        languageEs.forEach((el) => (el.style.display = "none"));
        languageIt.forEach((el) => (el.style.display = "none"));
        languageEn.forEach((el) => (el.style.display = "block"));
      }
    },
  },

  data() {
    return {
      zoom: 15,
      addressOptions: {
        zoomControl: true,
        disableScrollPropagation: false,
        scrollWheelZoom: true,
        touchZoom: true,
        doubleClickZoom: true,
        keyboard: false,
        dragging: true,
      },
    };
  },

  beforeMount() {
    this.getOptions();
  },

  mounted() {
    this.checkLanguage();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mapComponent.scss";

.st0 {
  fill: none;
  stroke: var(--mainColor);
  stroke-width: 3;
  stroke-miterlimit: 9.9961;
}
.st1, .feather-minimize {
  fill: none;
  stroke: var(--mainColor);
  stroke-width: 3;
}
.st2 {
  fill: none;
  stroke: var(--mainColor);
  stroke-width: 3;
  stroke-miterlimit: 10;
}
</style>
